import React from 'react';
import { LogOut, X } from 'lucide-react';
interface LogoutModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}
export function LogoutModal({
  onConfirm,
  onCancel
}: LogoutModalProps) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-id="element-212">
      <div className="w-full max-w-md bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl overflow-hidden" data-id="element-213">
        <div className="bg-gray-800 p-6 border-b border-gray-700 flex items-center justify-between" data-id="element-214">
          <div className="flex items-center gap-3" data-id="element-215">
            <div className="p-2 bg-red-900/30 rounded-lg" data-id="element-216">
              <LogOut className="w-6 h-6 text-red-400" data-id="element-217" />
            </div>
            <h2 className="text-xl font-bold text-white" data-id="element-218">Confirm Logout</h2>
          </div>
          <button onClick={onCancel} className="text-gray-400 hover:text-white" data-id="element-219">
            <X className="w-6 h-6" data-id="element-220" />
          </button>
        </div>

        <div className="p-6" data-id="element-221">
          <p className="text-gray-300 mb-6" data-id="element-222">
            Are you sure you want to log out? Any unsaved changes will be lost.
          </p>

          <div className="flex gap-4" data-id="element-223">
            <button onClick={onCancel} className="flex-1 px-4 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-xl font-bold transition-colors" data-id="element-224">
              Cancel
            </button>
            <button onClick={onConfirm} className="flex-1 px-4 py-3 bg-red-600 hover:bg-red-500 text-white rounded-xl font-bold transition-colors" data-id="element-225">
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>;
}